
import { captureException, setUser, sanitizeMsgForBreadcrumb, addBreadcrumb, hashEmail, init as init_1 } from "./Sentry.js";
import { equals, uncurry2, disposeSafe, getEnumerator } from "./fable_modules/fable-library-js.5.3.0/Util.js";
import { ofArray, empty, singleton } from "./fable_modules/fable-library-js.5.3.0/List.js";
import { Auto_generateBoxedDecoder_Z6670B51, fromString } from "./fable_modules/Thoth.Json.10.5.1/Decode.fs.js";
import { ClientTypes_initWithState, ClientTypes_init, ClientTypes_Msg, ClientTypes_Model, ClientTypes_PhotoUploadState, ClientTypes_DailyLogInterceptionState, PledgeLookup_fromPledgeList, ClientTypes_PledgeFormState, ClientTypes_SupportOthersSort, ClientTypes_PaymentState, ClientTypes_VerificationState, ClientTypes_RegistrationState, ClientTypes_NotificationPreferencesState, ClientTypes_ProfilePageState, ClientTypes_ProfileCompletionState, ClientTypes_AuthState, ClientTypes_Route, ClientTypes_Model_$reflection } from "./Shared/ClientTypes.js";
import { extra as extra_2 } from "./Shared/SsrCoders.js";
import { printf, toConsole, isNullOrEmpty } from "./fable_modules/fable-library-js.5.3.0/String.js";
import { getQueryParam, PostRegistrationStorage_load, navigate, postLoginRoute, parseUrl } from "./Router.js";
import { RouterModule_urlSegments } from "./Vendor/FelizRouter.js";
import { listenForOsChanges, apply, load } from "./ThemeManager.js";
import { ListState } from "./Shared/Challenge/ChallengeList.js";
import { fromParts } from "./fable_modules/fable-library-js.5.3.0/Decimal.js";
import { Cmd_OfPromise_perform, Cmd_none, Cmd_batch, Cmd_OfPromise_either } from "./fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { removeUser, TokenStorage_remove, decodeJwtEmail, isJwtExpired, TokenStorage_load, getUser, returnPathOf, handleCallback } from "./Auth/Auth.js";
import { map } from "./fable_modules/fable-library-js.5.3.0/Option.js";
import { toString } from "./fable_modules/fable-library-js.5.3.0/Types.js";
import { update } from "./Index.js";
import { ProgramModule_mkProgram, ProgramModule_withErrorHandler, ProgramModule_withSubscription, ProgramModule_run } from "./fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Program_withReactHydrate } from "./fable_modules/Fable.Elmish.React.5.6.0/react.fs.js";
import { view } from "./ClientView.js";
import "../index.css";


init_1();

function deferForHydration(cmd) {
    return singleton((dispatch) => {
        setTimeout(() => {
            const enumerator = getEnumerator(cmd);
            try {
                while (enumerator["System.Collections.IEnumerator.MoveNext"]()) {
                    enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]()(dispatch);
                }
            }
            finally {
                disposeSafe(enumerator);
            }
        }, 0);
    });
}

export function init() {
    let callbackCmd, matchValue_1, code_1;
    const initState = window.__INIT_STATE__;
    let ssrModel;
    let matchResult, jsonStr_1;
    if (typeof initState === "string") {
        if (!isNullOrEmpty(initState)) {
            matchResult = 0;
            jsonStr_1 = initState;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const matchValue = fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(ClientTypes_Model_$reflection(), undefined, extra_2)), jsonStr_1);
            if (matchValue.tag === 1) {
                matchValue.fields[0];
                ssrModel = undefined;
            }
            else {
                ssrModel = matchValue.fields[0];
            }
            break;
        }
        default:
            ssrModel = undefined;
    }
    const route = (ssrModel == null) ? parseUrl(RouterModule_urlSegments(window.location.pathname + window.location.search, 2)) : ssrModel.CurrentRoute;
    if (equals(route, new ClientTypes_Route(7, []))) {
        toConsole(printf("App: Handling auth callback route"));
        const initialTheme = load();
        apply(initialTheme);
        listenForOsChanges();
        return [new ClientTypes_Model("", new ClientTypes_AuthState(2, []), undefined, undefined, false, route, undefined, new ClientTypes_ProfileCompletionState(0, []), new ClientTypes_ProfilePageState(0, []), new ClientTypes_NotificationPreferencesState(0, []), new ClientTypes_RegistrationState(0, []), new ClientTypes_VerificationState(0, []), undefined, undefined, false, undefined, new ClientTypes_PaymentState(0, []), 0, undefined, new ListState(1, []), new ListState(1, []), undefined, new ListState(1, []), new ClientTypes_SupportOthersSort(0, []), initialTheme, false, false, new ClientTypes_PledgeFormState(0, []), undefined, false, undefined, false, undefined, false, undefined, PledgeLookup_fromPledgeList(empty()), empty(), 0, 0, 0, 0, fromParts(0, 0, 0, false, 0), false, false, undefined, false, undefined, false, undefined, new ClientTypes_DailyLogInterceptionState(0, []), undefined, false, undefined, false, 0, false, undefined, empty(), false, undefined, undefined, false, false, undefined, false, 0, empty(), false, undefined, false, 0, new ClientTypes_PhotoUploadState(0, []), undefined), (callbackCmd = Cmd_OfPromise_either(handleCallback, undefined, (user) => {
            const returnRoute = postLoginRoute(returnPathOf(user));
            toConsole(printf("App: Auth callback successful, navigating to %A"))(returnRoute);
            navigate(returnRoute);
            return new ClientTypes_Msg(9, []);
        }, (error) => {
            toConsole(printf("App: Auth callback failed: %A"))(error);
            return new ClientTypes_Msg(36, ["Login failed. Please try again."]);
        }), (ssrModel != null) ? deferForHydration(callbackCmd) : callbackCmd)];
    }
    else {
        let patternInput_1;
        if (ssrModel == null) {
            toConsole(printf("App: No SSR model, initializing fresh"));
            const patternInput = ClientTypes_init();
            const m_1 = patternInput[0];
            patternInput_1 = [new ClientTypes_Model(m_1.Input, m_1.Auth, m_1.EnsureRegisteredRequestId, m_1.AuthError, m_1.ShowUserMenu, route, m_1.PostRegistrationRoute, m_1.ProfileCompletion, m_1.ProfilePage, m_1.NotificationPreferences, m_1.Registration, m_1.Verification, m_1.CurrentChallenge, m_1.FeeShareSchedule, m_1.LoadingChallenge, m_1.ChallengeLoadError, m_1.Payment, m_1.PaymentVerificationAttempt, m_1.PaymentSessionId, m_1.Challenges, m_1.CompletedChallenges, m_1.CurrentUserId, m_1.PublicChallenges, m_1.SupportOthersSort, m_1.ThemePreference, m_1.ShowThemeMenu, m_1.ShowMobileMenu, m_1.PledgeForm, m_1.UserPledgeForChallenge, m_1.LoadingUserPledge, m_1.CurrentPledge, m_1.LoadingPledge, m_1.MyPledges, m_1.LoadingMyPledges, m_1.MyPledgesError, m_1.PledgeLookup, m_1.ChallengePledgeItems, m_1.ChallengePledgesCurrentPage, m_1.ChallengePledgesTotalPages, m_1.ChallengePledgesTotalItems, m_1.ChallengePledgesActivePledgeCount, m_1.ChallengePledgesActiveTotalPledged, m_1.ChallengePledgesAllLoaded, m_1.ChallengePledgesLoadingMore, m_1.ChallengePledgesLoadMoreError, m_1.LoadingChallengePledges, m_1.ChallengePledgesError, m_1.ShowAbandonedPledges, m_1.CascadePrompt, m_1.DailyLogInterception, m_1.DailyLogs, m_1.LoadingDailyLogs, m_1.DailyLogsError, m_1.DailyLogsHasMore, m_1.DailyLogsServerLoaded, m_1.LoadingMoreDailyLogs, m_1.DailyLogsLoadMoreError, m_1.LoggedDays, m_1.SubmittingDailyLog, m_1.DailyLogSubmitError, m_1.OpenDailyLogForm, m_1.DailyLogDraftHasInput, m_1.ShowAllMissedDays, m_1.FeeShareStatus, m_1.LoadingFeeShareStatus, m_1.FeeSharePollAttempts, m_1.PublicDailyLogs, m_1.LoadingPublicDailyLogs, m_1.PublicDailyLogsError, m_1.PublicDailyLogsHasMore, m_1.PublicDailyLogsPage, m_1.PhotoUpload, m_1.Moderation), patternInput[1]];
        }
        else {
            const model_1 = ssrModel;
            toConsole(printf("App: Using SSR model with route: %A"))(model_1.CurrentRoute);
            patternInput_1 = ClientTypes_initWithState(model_1);
        }
        const model_2 = patternInput_1[0];
        const initialTheme_1 = load();
        apply(initialTheme_1);
        listenForOsChanges();
        const model_3 = new ClientTypes_Model(model_2.Input, model_2.Auth, model_2.EnsureRegisteredRequestId, model_2.AuthError, model_2.ShowUserMenu, model_2.CurrentRoute, PostRegistrationStorage_load(), model_2.ProfileCompletion, model_2.ProfilePage, model_2.NotificationPreferences, model_2.Registration, model_2.Verification, model_2.CurrentChallenge, model_2.FeeShareSchedule, model_2.LoadingChallenge, model_2.ChallengeLoadError, model_2.Payment, model_2.PaymentVerificationAttempt, model_2.PaymentSessionId, model_2.Challenges, model_2.CompletedChallenges, model_2.CurrentUserId, model_2.PublicChallenges, model_2.SupportOthersSort, initialTheme_1, model_2.ShowThemeMenu, model_2.ShowMobileMenu, model_2.PledgeForm, model_2.UserPledgeForChallenge, model_2.LoadingUserPledge, model_2.CurrentPledge, model_2.LoadingPledge, model_2.MyPledges, model_2.LoadingMyPledges, model_2.MyPledgesError, model_2.PledgeLookup, model_2.ChallengePledgeItems, model_2.ChallengePledgesCurrentPage, model_2.ChallengePledgesTotalPages, model_2.ChallengePledgesTotalItems, model_2.ChallengePledgesActivePledgeCount, model_2.ChallengePledgesActiveTotalPledged, model_2.ChallengePledgesAllLoaded, model_2.ChallengePledgesLoadingMore, model_2.ChallengePledgesLoadMoreError, model_2.LoadingChallengePledges, model_2.ChallengePledgesError, model_2.ShowAbandonedPledges, model_2.CascadePrompt, model_2.DailyLogInterception, model_2.DailyLogs, model_2.LoadingDailyLogs, model_2.DailyLogsError, model_2.DailyLogsHasMore, model_2.DailyLogsServerLoaded, model_2.LoadingMoreDailyLogs, model_2.DailyLogsLoadMoreError, model_2.LoggedDays, model_2.SubmittingDailyLog, model_2.DailyLogSubmitError, model_2.OpenDailyLogForm, model_2.DailyLogDraftHasInput, model_2.ShowAllMissedDays, model_2.FeeShareStatus, model_2.LoadingFeeShareStatus, model_2.FeeSharePollAttempts, model_2.PublicDailyLogs, model_2.LoadingPublicDailyLogs, model_2.PublicDailyLogsError, model_2.PublicDailyLogsHasMore, model_2.PublicDailyLogsPage, model_2.PhotoUpload, model_2.Moderation);
        toConsole(printf("App: Checking for existing authentication on startup"));
        const allCmds = Cmd_batch(ofArray([patternInput_1[1], (route.tag === 9) ? ((matchValue_1 = getQueryParam("code"), (matchValue_1 != null) ? ((matchValue_1 !== "") ? ((code_1 = matchValue_1, (toConsole(printf("App: Found verification code in URL: %s"))(code_1), singleton((dispatch) => {
            dispatch(new ClientTypes_Msg(27, [code_1]));
        })))) : Cmd_none()) : Cmd_none())) : Cmd_none(), Cmd_OfPromise_perform(getUser, undefined, (userOpt) => {
            if (userOpt == null) {
                const matchValue_2 = TokenStorage_load();
                if (matchValue_2 == null) {
                    toConsole(printf("App: No existing user found on startup"));
                    return new ClientTypes_Msg(10, [new ClientTypes_AuthState(0, [])]);
                }
                else if (!isJwtExpired(matchValue_2)) {
                    const token_1 = matchValue_2;
                    toConsole(printf("App: No OIDC session, but found valid server-issued JWT in localStorage"));
                    const email = decodeJwtEmail(token_1);
                    return new ClientTypes_Msg(10, [new ClientTypes_AuthState(1, [token_1, email, false, map(hashEmail, email)])]);
                }
                else {
                    toConsole(printf("App: Found expired JWT in localStorage, clearing"));
                    TokenStorage_remove();
                    return new ClientTypes_Msg(10, [new ClientTypes_AuthState(0, [])]);
                }
            }
            else {
                const user_1 = userOpt;
                if (user_1.expired) {
                    toConsole(printf("App: OIDC user found but token is expired, clearing"));
                    TokenStorage_remove();
                    removeUser();
                    return new ClientTypes_Msg(10, [new ClientTypes_AuthState(0, [])]);
                }
                else {
                    toConsole(printf("App: Existing user found on startup"));
                    const accessToken = user_1.access_token;
                    let email_2;
                    const emailValue = userOpt.profile.email;
                    email_2 = ((emailValue == null) ? undefined : toString(emailValue));
                    toConsole(printf("App: Setting authenticated state on startup with email: %A"))(email_2);
                    return new ClientTypes_Msg(10, [new ClientTypes_AuthState(1, [accessToken, email_2, false, map(hashEmail, email_2)])]);
                }
            }
        })]));
        return [model_3, (ssrModel != null) ? deferForHydration(allCmds) : allCmds];
    }
}

export function subscriptions(_model) {
    return empty();
}

/**
 * Wraps the Elmish update to log breadcrumbs and sync Sentry user identity.
 */
export function updateWithSentry(msg, model) {
    addBreadcrumb("elmish", sanitizeMsgForBreadcrumb(msg));
    let matchResult, monitoringId;
    if (msg.tag === 10) {
        switch (msg.fields[0].tag) {
            case 1: {
                matchResult = 0;
                monitoringId = msg.fields[0].fields[3];
                break;
            }
            case 0: {
                matchResult = 1;
                break;
            }
            default:
                matchResult = 2;
        }
    }
    else {
        matchResult = 2;
    }
    switch (matchResult) {
        case 0: {
            setUser(monitoringId);
            break;
        }
        case 1: {
            setUser(undefined);
            break;
        }
    }
    return update(msg, model);
}

/**
 * Elmish error handler — captures unhandled exceptions in Sentry.
 */
export function onError(message, ex) {
    captureException(ex);
    const arg_1 = ex.message;
    toConsole(printf("Elmish error: %s — %s"))(message)(arg_1);
}

ProgramModule_run(Program_withReactHydrate("elmish-app", ProgramModule_withSubscription(subscriptions, ProgramModule_withErrorHandler((tupledArg) => {
    onError(tupledArg[0], tupledArg[1]);
}, ProgramModule_mkProgram(init, updateWithSentry, view)))));

//# sourceMappingURL=App.js.map
